import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useYoutubeEmbed from "../utils/useYoutubeEmbed";


const Home = () => {

  const embedUrl = useYoutubeEmbed("/api/hero-video/", "27AA1JzF-68");


  const sliderImages = [
    "/images/church3.png",
    "/images/church1.jpg",
    "/images/church2.jpg",
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % sliderImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);


  return (
    <>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" />
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css" />





      {/* HERO */}
      <section className="hero-section position-relative overflow-hidden">
        <iframe
          className="hero-video"
          src={embedUrl}
          title="YouTube video player" 
          frameBorder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
          referrerPolicy="strict-origin-when-cross-origin" 
          allowFullScreen
        />
        <div className="hero-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
          <div className="hero-content text-center text-white w-100">

            {/* Static "Welcome to" */}
            <p className="hero-tagline text-uppercase mb-3">Welcome to</p>

            {/* Church name — slides right to left */}
            <div className="hero-marquee-wrapper mb-2">
              <div className="hero-marquee-fade-left" />
              <div className="hero-marquee-fade-right" />
              <div className="hero-marquee-track hero-marquee-rtl">
                {[...Array(4)].map((_, i) => (
                  <span key={i} className="hero-marquee-item display-3 fw-bold">
                    Gospel City Church International
                    <span className="hero-marquee-dot" />
                  </span>
                ))}
              </div>
            </div>

            {/* Tagline — slides left to right */}
            <div className="hero-marquee-wrapper mb-4">
              <div className="hero-marquee-fade-left" />
              <div className="hero-marquee-fade-right" />
              <div className="hero-marquee-track hero-marquee-ltr">
                {[...Array(4)].map((_, i) => (
                  <span key={i} className="hero-marquee-item hero-sub fs-5">
                    Transforming lives through the Word, Worship, Prayer, Praise, and love.
                    <span className="hero-marquee-dot" />
                  </span>
                ))}
              </div>
            </div>

            <a href="/join" className="btn btn-primary btn-lg rounded-pill px-4">Join Us This Sunday</a>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="about-section py-5 bg-light">
        <div className="container py-4">
          <div className="text-center">
            <span className="badge bg-info bg-opacity-10 text-info text-uppercase mb-3">Who We Are</span>
            <h2 className="display-5 fw-bold text-primary mb-4">About GCCI</h2>
            <p className="lead mx-auto" style={{ maxWidth: '780px' }}>
              Gospel City Church International is a non-denominational non-christian church founded by{" "}
              <strong>Pr Keffah Evans Muwanguzi</strong>. Located at{" "}
              <strong>Naguru Go Down, Nakawa Division, Kampala Capital City</strong>, Uganda —
              with a vision that <em>they may all get into knowledge of one holy true living God</em>,
              creator of the universe, and a mission of making the world know God.
            </p>
          </div>
        </div>
      </section>

      {/* SLIDER */}
      <section className="stable-slider py-5">
        <div className="container position-relative">
          <button
            className="btn btn-light rounded-circle position-absolute top-50 start-0 translate-middle-y slide-btn"
            onClick={() => setIndex((index - 1 + sliderImages.length) % sliderImages.length)}
            aria-label="Previous"
          >
            <i className="bi bi-chevron-left"></i>
          </button>
          <div className="slider-window overflow-hidden rounded-4 shadow-lg">
            <div className="slider-track d-flex" style={{ transform: `translateX(-${index * 100}%)`, transition: 'transform 1.1s cubic-bezier(0.77,0,0.18,1)' }}>
              {sliderImages.map((img, i) => (
                <div key={i} className="position-relative w-100 flex-shrink-0" style={{ height: 'clamp(220px,45vw,480px)' }}>
                  <img
                    src={img}
                    alt={`Church ${i + 1}`}
                    className="w-100 h-100"
                    style={{ objectFit: 'cover' }}
                  />
                  <div className="slider-caption position-absolute start-0 end-0 bottom-0 text-white text-center py-3 px-2"
                       style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)', zIndex: 5 }}>
                    <h5 className="mb-0 fw-bold" style={{ fontSize: 'clamp(0.9rem, 4vw, 1.2rem)' }}>Gospel City Church International</h5>
                    <p className="mb-0 small" style={{ fontSize: 'clamp(0.7rem, 3vw, 0.85rem)', opacity: 0.9 }}>Restoring the world back to God</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <button
            className="btn btn-light rounded-circle position-absolute top-50 end-0 translate-middle-y slide-btn"
            onClick={() => setIndex((index + 1) % sliderImages.length)}
            aria-label="Next"
          >
            <i className="bi bi-chevron-right"></i>
          </button>
          <div className="d-flex justify-content-center gap-2 mt-3">
            {sliderImages.map((_, i) => (
              <button
                key={i}
                className={`btn btn-sm rounded-circle p-0 dot ${i === index ? "active" : ""}`}
                onClick={() => setIndex(i)}
                style={{ width: '10px', height: '10px' }}
              />
            ))}
          </div>
        </div>
      </section>

      {/* VISION & MISSION */}
      <section className="vm-section py-5">
        <div className="container">
          <div className="row g-0 align-items-stretch">
            <div className="col-md-6">
              <div className="vm-card text-center text-white p-5">
                <div className="vm-icon mb-3 fs-3">
                  <i className="bi bi-star-fill"></i>
                </div>
                <h3 className="text-uppercase fw-bold mb-3">Our Vision</h3>
                <p className="fs-6">That they may all get into knowledge of one holy true living God.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="vm-card text-center text-white p-5">
                <div className="vm-icon mb-3 fs-3">
                  <i className="bi bi-star-fill"></i>
                </div>
                <h3 className="text-uppercase fw-bold mb-3">Our Mission</h3>
                <p className="fs-6">To make the world know God.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PASTOR */}
      <section className="pastor-section container my-5">
        <div className="row align-items-center">
          <div className="col-md-5 pastor-image-wrapper">
            <img src="/images/pastor3.png" alt="Senior Pastor" className="pastor-img" />
          </div>
          <div className="col-md-7 pastor-content">
            <h2 className="pastor-title">Pastor's Call to Ministry</h2>
            <h3>Scared to be a pastor</h3>
            <p>Two times, I got messages to start a church but I declined and rather got a pastor to do it as I sponsored the church progress.</p>
            <p>Second time, still, I refused and took over other church responsibilities other than pastoring.</p>
            <Link to="/read" className="read-more-link">Read more →</Link>
          </div>
        </div>
      </section>

      {/* LEADERS */}
      <section className="leaders-section py-5">
        <div className="leaders-watermark">✝</div>
        <div className="container py-4" style={{ position: 'relative', zIndex: 1 }}>
          <div className="text-center mb-5">
            <span className="leaders-eyebrow">Serving With Purpose</span>
            <h2 className="leaders-title">Church <em>Leadership</em></h2>
            <div className="leaders-rule"><div className="leaders-rule-diamond" /></div>
          </div>
          <div className="row g-4 justify-content-center">
            {[
              { src: "/images/1.jpeg", name: "Pr Keffah Evans Muwanguzi", title: "Senior Pastor", bio: "Leading God's people with wisdom for years, Pr Keffah nurtures spiritual growth and guides our community with unwavering faith." },
              { src: "/images/3.jpeg", name: "Mrs Faith Muwanguzi", title: "Praise & worship leader", bio: "Passionate praise and worship team leader. She is a mother, mentor and minister of God.", facebook: "#", twitter: "#", instagram: "#" },
              { src: "/images/4.png", name: "Pr Oryem David", title: "Pastor", bio: "Leading a fellowship in Gulu city, Pr David selflessly serves God & mentors upcoming ministers towards attaining a new life in God.", facebook: "#", twitter: "#", instagram: "#" }
            ].map((leader, i) => (
              <div className="col-lg-4 col-md-6" key={i}>
                <div className="leader-card h-100">
                  <div className="leader-img-wrap">
                    <img src={leader.src} alt={leader.name} className="leader-img" />
                    <div className="leader-img-scrim" />
                    <div className="leader-gold-bar" />
                  </div>
                  <div className="leader-body">
                    <span className="leader-role">{leader.title}</span>
                    <h5 className="leader-name">{leader.name}</h5>
                    <p className="leader-bio">{leader.bio}</p>
                    <div className="leader-divider" />
                    <div className="leader-socials">
                      <a href={leader.facebook} className="leader-social-btn" aria-label="Facebook">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
                      </a>
                      <a href={leader.twitter} className="leader-social-btn" aria-label="Twitter">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/></svg>
                      </a>
                      <a href={leader.instagram} className="leader-social-btn" aria-label="Instagram">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="contact-section py-5 bg-light">
        <div className="container py-4">
          <div className="text-center mb-5">
            <span className="badge bg-info bg-opacity-10 text-info text-uppercase mb-3">Get in Touch</span>
            <h2 className="display-5 fw-bold text-primary">Contact Details</h2>
          </div>
          <div className="row g-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border rounded-4 shadow-sm h-100 p-4">
                <span className="text-info text-uppercase fw-bold mb-2" style={{ fontSize: '11px', letterSpacing: '1.5px' }}>WhatsApp & IMO</span>
                <span className="fw-medium">+256 783 359 816</span>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border rounded-4 shadow-sm h-100 p-4">
                <span className="text-info text-uppercase fw-bold mb-2" style={{ fontSize: '11px', letterSpacing: '1.5px' }}>Pastors</span>
                <span className="fw-medium d-block">+256 775 257 051</span>
                <span className="fw-medium d-block">+256 772 871 632</span>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border rounded-4 shadow-sm h-100 p-4">
                <span className="text-info text-uppercase fw-bold mb-2" style={{ fontSize: '11px', letterSpacing: '1.5px' }}>Administrators</span>
                <span className="fw-medium d-block">+256 775 028 569</span>
                <span className="fw-medium d-block">+256 782 987 207</span>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border rounded-4 shadow-sm h-100 p-4">
                <span className="text-info text-uppercase fw-bold mb-2" style={{ fontSize: '11px', letterSpacing: '1.5px' }}>Pastor Emails</span>
                <span className="fw-medium d-block" style={{ fontSize: '14px', wordBreak: 'break-word' }}>faithmuwanguzi@gmail.com</span>
                <span className="fw-medium d-block" style={{ fontSize: '14px', wordBreak: 'break-word' }}>muwanguzikeffah@gmail.com</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SOCIAL */}
      <section className="social-section py-5 text-center text-white">
        <div className="container py-4">
          <h2 className="display-5 fw-bold mb-3">Follow Us</h2>
          <p className="fs-6 mb-4 mx-auto" style={{ maxWidth: '600px' }}>Stay connected with Gospel City Church International through our social platforms.</p>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <a href="https://www.linkedin.com/in/gospel-city-church-international-650a562a0/" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-circle social-icon"><i className="bi bi-linkedin fs-4"></i></a>
            <a href="https://groups.imo.im/.5l9akqTOrYa5Tv4T4" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-circle social-icon"><i className="bi bi-chat-dots fs-4"></i></a>
            <a href="https://x.com/GospelCityChur?t=x8dsFbFkghmYh02lV0FVxQ&s=03" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-circle social-icon"><i className="bi bi-twitter-x fs-4"></i></a>
            <a href="https://whatsapp.com/channel/0029Vb769UyDzgTBAZZcb40F" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-circle social-icon"><i className="bi bi-whatsapp fs-4"></i></a>
            <a href="https://youtube.com/@gospelcitychurchinternational?si=1pZx2ak4ss3b4HuU" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-circle social-icon"><i className="bi bi-youtube fs-4"></i></a>
          </div>
        </div>
      </section>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Lexend:wght@300;400;500;600;700;800&display=swap');

        * { font-family: 'Lexend', sans-serif; }

        /* ── HERO ── */
        .hero-section {
          height: 100vh;
          min-height: 520px;
        }

        .hero-video {
          position: absolute;
          top: 50%; left: 50%;
          width: 100vw; height: 100vh;
          transform: translate(-50%, -50%);
          pointer-events: none;
        }

        @media (min-aspect-ratio: 16/9) { .hero-video { height: 56.25vw; } }
        @media (max-aspect-ratio: 16/9) { .hero-video { width: 177.78vh; } }

        .hero-overlay {
          background: linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(11,28,107,0.55) 100%);
          z-index: 1;
        }

        .hero-content { max-width: 100%; }

        .hero-tagline {
          font-size: clamp(13px, 2vw, 17px);
          letter-spacing: 4px;
          opacity: 0.85;
        }

        /* Marquee container */
        .hero-marquee-wrapper {
          position: relative;
          overflow: hidden;
          width: 100%;
        }

        /* Soft edge fades so text doesn't hard-cut */
        .hero-marquee-fade-left,
        .hero-marquee-fade-right {
          position: absolute;
          top: 0; bottom: 0;
          width: 80px;
          z-index: 2;
          pointer-events: none;
        }
        .hero-marquee-fade-left  { left: 0;  background: linear-gradient(to right, rgba(11,28,107,0.55), transparent); }
        .hero-marquee-fade-right { right: 0; background: linear-gradient(to left,  rgba(11,28,107,0.55), transparent); }

        /* The scrolling track */
        .hero-marquee-track {
          display: flex;
          white-space: nowrap;
          will-change: transform;
        }
        .hero-marquee-rtl { animation: heroScrollRTL 22s linear infinite; }
        .hero-marquee-ltr { animation: heroScrollLTR 22s linear infinite; }

        .hero-marquee-item {
          display: inline-flex;
          align-items: center;
          gap: 1.5rem;
          padding: 0 2rem;
          margin-top: 1rem;
          color: #fff;
          text-shadow: 0 3px 20px rgba(0,0,0,0.4);
        }

        .hero-marquee-dot {
          display: inline-block;
          width: 6px; height: 6px;
          border-radius: 50%;
          background: rgba(255,255,255,0.45);
          flex-shrink: 0;
        }

        .hero-sub { opacity: 0.9; }

        @keyframes heroScrollRTL {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes heroScrollLTR {
          0%   { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }

        /* ── REST OF STYLES (unchanged) ── */
        .btn-primary { background: #0b1c6b; border-color: #0b1c6b; }
        .btn-primary:hover { background: #159EEC; border-color: #159EEC; transform: translateY(-2px); box-shadow: 0 8px 30px rgba(21,158,236,0.4); }
        .text-primary { color: #1a3aa1 !important; }
        .text-info { color: #159EEC !important; }
        .bg-info { background-color: #159EEC !important; }

        .slide-btn { width: 44px; height: 44px; z-index: 10; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 16px rgba(0,0,0,0.15); }
        .slide-btn:hover { background: #1a3aa1 !important; color: #fff !important; transform: translateY(-50%) scale(1.08); }
        .dot { background: #c0cce8; border: none; }
        .dot.active { background: #1a3aa1; transform: scale(1.35); }

        .vm-section { background: linear-gradient(135deg,#0b1c6b 0%,#1a3aa1 60%,#159EEC 100%); }
        .vm-icon { color: rgba(255,255,255,0.5); }

        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Jost:wght@300;400;500;600&display=swap');
        :root { --navy: #0f2557; --navy-light: #1a3a8f; --gold: #c9a84c; --gold-light: #e8c97a; --gold-pale: #fdf6e3; --cream: #fafaf7; --text-muted: #7a8099; }

        .leaders-section { background: var(--cream); position: relative; overflow: hidden; }
        .leaders-section::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse 600px 400px at 10% 20%, rgba(201,168,76,0.06) 0%, transparent 70%), radial-gradient(ellipse 500px 350px at 90% 80%, rgba(15,37,87,0.05) 0%, transparent 70%); pointer-events: none; }
        .leaders-eyebrow { font-family: 'Jost', sans-serif; font-size: 0.7rem; font-weight: 600; letter-spacing: 0.28em; text-transform: uppercase; color: var(--gold); display: block; margin-bottom: 0.6rem; }
        .leaders-title { font-family: 'Cormorant Garamond', serif; font-size: clamp(2.4rem, 5vw, 3.6rem); font-weight: 700; color: var(--navy); line-height: 1.05; letter-spacing: -0.02em; margin: 0; }
        .leaders-title em { font-style: italic; color: var(--gold); }
        .leaders-rule { display: flex; align-items: center; justify-content: center; gap: 0.75rem; margin: 1.25rem auto 0; width: fit-content; }
        .leaders-rule::before, .leaders-rule::after { content: ''; width: 48px; height: 1px; background: linear-gradient(90deg, transparent, var(--gold)); }
        .leaders-rule::after { background: linear-gradient(90deg, var(--gold), transparent); }
        .leaders-rule-diamond { width: 7px; height: 7px; background: var(--gold); transform: rotate(45deg); flex-shrink: 0; }

        .leader-card { background: #fff; border-radius: 20px; overflow: hidden; border: 1px solid rgba(15,37,87,0.07); box-shadow: 0 2px 16px rgba(15,37,87,0.06), 0 1px 3px rgba(15,37,87,0.04); transition: transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.45s ease; position: relative; animation: cardReveal 0.6s ease both; }
        .leader-card:nth-child(1) { animation-delay: 0.1s; }
        .leader-card:nth-child(2) { animation-delay: 0.25s; }
        .leader-card:nth-child(3) { animation-delay: 0.4s; }
        @keyframes cardReveal { from { opacity: 0; transform: translateY(28px); } to { opacity: 1; transform: translateY(0); } }
        .leader-card:hover { transform: translateY(-12px) scale(1.01); box-shadow: 0 28px 60px rgba(15,37,87,0.14), 0 8px 20px rgba(15,37,87,0.08), 0 0 0 1px rgba(201,168,76,0.2); }
        .leader-img-wrap { position: relative; overflow: hidden; height: 360px; }
        .leader-img { width: 100%; height: 100%; object-fit: cover; object-position: center top; display: block; transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94); transform-origin: center top; }
        .leader-card:hover .leader-img { transform: scale(1.05); }
        .leader-img-scrim { position: absolute; bottom: 0; left: 0; right: 0; height: 80px; background: linear-gradient(to top, rgba(255,255,255,0.95), transparent); pointer-events: none; }
        .leader-gold-bar { position: absolute; bottom: 0; left: 0; right: 0; height: 3px; background: linear-gradient(90deg, transparent 0%, var(--gold) 35%, var(--gold-light) 65%, transparent 100%); opacity: 0; transition: opacity 0.35s ease; }
        .leader-card:hover .leader-gold-bar { opacity: 1; }
        .leader-body { padding: 1.4rem 1.5rem 1.25rem; }
        .leader-role { font-family: 'Jost', sans-serif; font-size: 0.65rem; font-weight: 600; letter-spacing: 0.22em; text-transform: uppercase; color: var(--gold); margin-bottom: 0.3rem; display: block; }
        .leader-name { font-family: 'Cormorant Garamond', serif; font-size: 1.45rem; font-weight: 700; color: var(--navy); margin: 0 0 0.75rem; letter-spacing: -0.01em; line-height: 1.15; }
        .leader-bio { font-family: 'Jost', sans-serif; font-size: 0.84rem; font-weight: 300; color: var(--text-muted); line-height: 1.7; margin: 0 0 1.2rem; }
        .leader-divider { height: 1px; background: linear-gradient(90deg, transparent, rgba(15,37,87,0.1) 30%, rgba(15,37,87,0.1) 70%, transparent); margin-bottom: 1.1rem; }
        .leader-socials { display: flex; gap: 0.5rem; justify-content: center; }
        .leader-social-btn { width: 34px; height: 34px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background: rgba(15,37,87,0.05); color: var(--navy); text-decoration: none; border: 1px solid rgba(15,37,87,0.08); transition: background 0.25s ease, color 0.25s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), border-color 0.25s ease, box-shadow 0.25s ease; }
        .leader-social-btn:hover { background: var(--gold); color: #fff; border-color: var(--gold); transform: scale(1.2) translateY(-2px); box-shadow: 0 4px 12px rgba(5,84,253,0.4); }
        .leaders-watermark { position: absolute; bottom: 30px; right: 40px; opacity: 0.03; font-size: 140px; line-height: 1; font-family: 'Cormorant Garamond', serif; color: var(--navy); pointer-events: none; user-select: none; }

        .social-section { background: linear-gradient(135deg,#0b1c6b,#159EEC); }
        .social-icon { width: 52px; height: 52px; display: flex; align-items: center; justify-content: center; transition: all 0.3s; }
        .social-icon:hover { background: rgba(255,255,255,0.3); transform: translateY(-4px) scale(1.1); }

        @media (max-width: 768px) {
          .hero-marquee-fade-left, .hero-marquee-fade-right { width: 30px; }
        }

        .pastor-section { background: linear-gradient(135deg, #fff8f0, #fff3e6); padding: 4rem 2rem; border-radius: 1.5rem; box-shadow: 0 15px 35px rgba(0,0,0,0.1); transition: transform 0.3s ease, box-shadow 0.3s ease; }
        .pastor-section:hover { transform: translateY(-5px); box-shadow: 0 25px 50px rgba(0,0,0,0.15); }
        .pastor-image-wrapper { text-align: center; }
        .pastor-img { max-width: 200%; border-radius: 1rem; border: 5px solid #ffd700; box-shadow: 0 10px 25px rgba(0,0,0,0.12); transition: transform 0.3s ease; }
        .pastor-img:hover { transform: scale(1.05); }
        .pastor-content { padding: 1rem 2rem; }
        .pastor-title { font-family: 'Lexend', sans-serif; font-weight: 700; font-size: 2.5rem; color: #1a3aa1; margin-bottom: 1rem; }
        .pastor-content h3 { font-size: 1.8rem; color: #333; margin-bottom: 1rem; font-weight: 500; }
        .pastor-content p { font-size: 1.1rem; line-height: 1.8; color: #555; margin-bottom: 1rem; }
        .read-more-link { display: inline-block; margin-top: 1rem; font-weight: 600; color: #1a3aa1; text-decoration: none; border-bottom: 2px solid transparent; transition: all 0.3s ease; }
        .read-more-link:hover { border-color: #3d68f3; transform: translateX(5px); }
      `}</style>
    </>
  );
};

export default Home;